import React, { useEffect } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import { Modal as BootstrapModal } from "react-bootstrap";

import { useStores } from "../../../contexts/StoreContext";

function Modal() {
  const { modalStore } = useStores();
  const { clearModal, closeModal, modalData, isOpen } = modalStore;

  useEffect(() => {
    if (!isOpen) {
      if (typeof modalData.closeAction === "function") {
        modalData.closeAction();
      }
      clearModal();
    }
  }, [isOpen]);
  if (!modalData.content) {
    return null;
  }

  const contentClassName = classNames({
    "overflow-visible": modalData?.overflowVisible,
  });

  return (
    <BootstrapModal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName={contentClassName}
      fullscreen={modalData?.fullscreen}
      onHide={closeModal}
      scrollable
      show={isOpen}
      size={modalData?.size || "lg"}
    >
      {modalData.content}
    </BootstrapModal>
  );
}

export default observer(Modal);
